const selectApp = (state) => state.app

export const selectAppLocale = (state) => selectApp(state).i18n
export const selectAppUser = (state) => selectApp(state).user
export const selectAppDrawerState = (state) => selectApp(state).drawerState
// export const selectAppTicketsCounter = (state) => selectApp(state).ticketsCounter
